import { TipoPopUpEnum } from '../utilidades.index';

export class PopUpModel {
	public Ancho: number = 700;
	public Alto: number = 550;
	public Titulo: string = "";
	public Mensaje: string[] = [];
	SiClick = () => { }
	NoClick = () => { }
	TipoDePopUp: TipoPopUpEnum = TipoPopUpEnum.Ninguno;
	SiLabel = "Aceptar";
	NoLabel = "Cancelar";
	public Url: string = "";
	public MostrarBotonCerrar: boolean = false;

	constructor() { }
}